import { DG_axios } from '../../../../custom/axios'

const urlDepartment = `/dogoo/department-rest/v2.0/departments`
const urlJobPosition = `/dogoo/job-position-rest/v2.0/job-positions`
const urlJobTitle = `/dogoo/job-position-rest/v2.0/job-titles`

export async function getDepartments(filter, page, pageSize, search, sort) {
    const response = await DG_axios.get(urlDepartment, {
        params: {
            filter,
            page,
            pageSize,
            search,
            sort
        }
    })
    return response?.data || []
}

export async function getDepartmentRoot(customerId) {
    const response = await DG_axios.get(urlDepartment + `/root/${customerId}`)
    return response?.data || []
}

export async function getJobPositions(
    filter,
    page,
    pageSize,
    search,
    sort,
    status
) {
    const response = await DG_axios.get(urlJobPosition, {
        params: {
            filter,
            page,
            pageSize,
            search,
            sort,
            status
        }
    })
    return response?.data || []
}

export async function getJobTitles(
    filter,
    page,
    pageSize,
    search,
    sort,
    status
) {
    const response = await DG_axios.get(urlJobTitle, {
        params: {
            filter,
            page,
            pageSize,
            search,
            sort,
            status
        }
    })
    return response?.data || []
}
